import { useState, useRef, useEffect } from 'react'
import type { SupportedLang } from '@properwallet/i18n'
import { useAppStore } from '../store/app.store'

const SHORT_LABEL: Record<SupportedLang, string> = {
  en: 'EN',
  ru: 'RU',
  zh: '中',
}

const FULL_LABEL: Record<SupportedLang, string> = {
  en: 'English',
  ru: 'Русский',
  zh: '中文',
}

const ORDER: SupportedLang[] = ['en', 'ru', 'zh']

export default function LanguageSwitcher() {
  const { lang, setLanguage } = useAppStore()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open])

  return (
    <div ref={ref} className="relative flex-shrink-0">
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        className="flex items-center gap-1"
        style={{
          background: 'rgba(255,255,255,0.06)',
          border: 'none',
          borderRadius: 999,
          cursor: 'pointer',
          padding: '5px 10px',
          color: '#e5e7eb',
          fontSize: 12,
          fontWeight: 600,
        }}
        title="Language"
      >
        {SHORT_LABEL[lang]}
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6,9 12,15 18,9" />
        </svg>
      </button>

      {open && (
        <div
          className="absolute right-0 mt-1.5 z-50 overflow-hidden"
          style={{
            background: '#181c18',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 12,
            minWidth: 120,
            boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
          }}
        >
          {ORDER.map(code => (
            <button
              key={code}
              type="button"
              onClick={() => {
                setLanguage(code)
                setOpen(false)
              }}
              className="w-full flex items-center justify-between"
              style={{
                background: code === lang ? 'rgba(92,191,99,0.12)' : 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '9px 12px',
                color: code === lang ? '#5cbf63' : '#e5e7eb',
                fontSize: 13,
                fontWeight: code === lang ? 600 : 500,
              }}
            >
              {FULL_LABEL[code]}
              {code === lang && (
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#5cbf63" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20,6 9,17 4,12" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
